/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import ComponentWithRouter from 'app/components/Routers/ComponentWithRouter.jsx';

let timeoutID = 0;

const minNavHeight = 625;

class Sidebar extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			height: window.visualViewport.height,
			hideFloaters: false
		}

		this.onResize = this.onResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
	}

	onResize() {
		if (this.state.hideFloaters === false) {
			this.setState({
				hideFloaters: true
			});
		}
		if (timeoutID) {
			window.clearTimeout(timeoutID);
			timeoutID = 0;
		}
		timeoutID = setTimeout(() => {
			this.setState({
				height: window.visualViewport.height,
				hideFloaters: false
			});
			timeoutID = 0;
		}, 250);

	}

	render(){
		let mainClass = classnames(
				'app-column',
				'content',
				{
					'left': (this.props.side === 'left') ? true : false,
					'right': (this.props.side === 'right') ? true : false
				}
			),
			floatingButtons = null;

		if (this.props.context !== 'client' && this.state.hideFloaters === false) {
			let floatClass = (this.state.height > minNavHeight) ? 'floating-buttons' : 'static-buttons';

			floatingButtons = (
				<div className={floatClass}>
					<div className="floating-button" role="button" onClick={(e) => {
						e.preventDefault();

						let idParam = '';
						if (this.props.router.params.socialId !== undefined) {
							idParam = `?id=${this.props.router.params.socialId}`;
						}

						this.props.router.navigate(`/content/post${idParam}`);

					}}>
						<div className="button-icon">
							<i className="icon ion-edit"/>
						</div>
						<div className="button-copy">
							New Post
						</div>
					</div>
					<div className="floating-button" role="button" onClick={(e) => {
						if (this.props.newSocialCallback !== null) {
							this.props.newSocialCallback.apply(this, []);
						} else {
							this.props.router.navigate("/config/socials?add=true");
						}
					}}>
						<div className="button-icon">
							<i className="icon ion-android-add"/>
						</div>
						<div className="button-copy">
							Add Social
						</div>
					</div>
				</div>
			);
		}

		return(
			<div className={mainClass}>
				<nav role="navigation">
					{this.props.navItems.map((item, i) => {
						var icon = null,
							iconClass = '',
							badge = null,
							badgeValue = 0,
							title = '',
							itemClass = classnames('sidebar-link', {
								'active': item.isActive || item.manualActive,
								'pointer': item.linkHandler ? true : false,
								'sub-menu': (item.isSubmenu !== undefined && item.isSubmenu) ? true : false
							});

						if (item.isHeader) {
							return (
								<div className={item.labelClass} key={i}>{item.label}</div>
							);
						} else if (item.isDivider) {
							return (
								<div className="sidebar-divider"/>
							);
						} else {
							if (item.iconComponent) {
								icon = item.iconComponent;
							} else {
								iconClass = item.iconClass;
								icon = (
									<div className="sidebar-icon-wrapper">
										<span className="va-helper"></span>
										<i className={iconClass}></i>
									</div>
								);
							}

							if (typeof item.badgeValueCallback === "function") {
								badgeValue = item.badgeValueCallback();
								badge = <div className={item.badgeClass}>{badgeValue}</div>;
							} else if (item.staticBadge) {
								badge = item.staticBadge;
							}

							if(item.hasOwnProperty('title') && item.title) {
								title = item.title;
							}

							if (item.link) {
								if (item.manualActive === false) {
									return (
										<NavLink
											to={item.link}
											key={i}
											title={title}
											className={({ isActive }) => isActive ? `${itemClass} active` : `${itemClass} active-shortcircuit`}
											onClick={item.linkHandler}>
											{icon}
											<div className={item.labelClass}>
												{item.label}
											</div>
											{badge}
										</NavLink>
									);
								} else {
									return (
										<NavLink
											to={item.link}
											key={i}
											title={title}
											className={({ isActive }) => isActive ? `${itemClass} active` : itemClass}
											onClick={item.linkHandler}>
											{icon}
											<div className={item.labelClass}>
												{item.label}
											</div>
											{badge}
										</NavLink>
									);
								}

							} else if (item.isCustom !== undefined && item.isCustom === true) {
								return (
									<div key={i}>
										{item.customNav}
									</div>
								);
							} else {
								return (
									<div key={i} title={title} className={itemClass} onClick={item.linkHandler} role="link" aria-label={item.label}>
										{icon}
										<div className={item.labelClass}>
											{item.label}
										</div>
										{badge}
									</div>
								);
							}
						}
					})}
					{this.state.height <= minNavHeight ? (
						floatingButtons
					) : null}
					<div>{"\u00A0"}</div>
				</nav>
				{this.state.height > minNavHeight ? (
					floatingButtons
				) : null}
			</div>
		);
	}
};

Sidebar.defaultProps = {
	/**
	 * each view should pass in a list of nav items of the form:
	 * navItems: [
	 *		{
	 *			iconComponent: 'An icon component to be rendered will override iconClass if present'
	 *			iconClass: 'Classnames to render a font-awesome icon',
	 *			label: 'Text label',
	 *			labelClass: 'class to attach to text label',
	 *			linkHandler: 'event handler for onClick event',
	 *			link: 'Link to pass to React-Router',
	 *			badgeValueCallback: Function which returns the count that should be displayed,
	 *			badgeClass: 'Class to apply to the badge',
	 *			staticBadge: 'used for icons and other right side decorations on buttons. badgeValueCallback gets precedence'
	 *			isHeader: false,
	 *			isDivider: false
	 *		}
	 * ]
	 */
	navItems: [],
	side: 'left',
	newSocialCallback: null,
	app: "dlvr"
};

export default ComponentWithRouter(Sidebar);
